export default "__VITE_ASSET__4L_iIeVe__"